<template>
	<div style="height: calc(100% - 40px);overflow: hidden;">
		<common-top :commonTopData="commonTopData"></common-top>
		<div style="height: calc(100% - 40px);overflow: hidden;">

			<ContributionReserve :tabsnum="tabsnum" @tabsChange2="tabsChange2"/>
			
		</div>
	</div>
</template>

<script>
import commonTop from '@/components/commonTop.vue'
import ContributionReserve from '@/views/workManager/contribution-reserve2/view.vue'
export default {
	components: {
		commonTop,
		ContributionReserve
	},
	data(){
		let permisstions = JSON.parse(localStorage.getItem('adminuseraccess'))
		let tabTopData = []
		let hasAll = permisstions.indexOf('264') > -1
		if (hasAll) {
			tabTopData.push({
				name: "投稿储备",
				accessid:"",
			})
		}
		if (permisstions.indexOf('269') > -1) {
			tabTopData.push({
				name: '入库作品',
				accessid: ''
			})
		}
		if (permisstions.indexOf('273') > -1) {
			tabTopData.push({
				name: '上线作品',
				accessid: ''
			})
		}
		if (permisstions.indexOf('273') > -1) {
			tabTopData.push({
				name: '下线作品',
				accessid: ''
			})
		}
		return{
			commonTopData: {
				"pageName": "workInfo",
				"commonleftbtn": [],
				"commonbottombtn": [],
				"tabTopData":tabTopData,
				'tabnums':0,
			},
			tabsnum:1
		}
	},
	methods:{
		tabsChange2(num) {
			console.log('触发tabsChange2')
			this.tabsnum = num
		},
		tabsChange(num) {
			console.log(num,'触发tabsChange')
			this.tabsnum = num+1; 
		},
	}
}
</script>
